export enum InfoCardSearchMode {
    Link,
    MultiSelect,
    Select,
}
